import { RouteComponentProps, withRouter } from "react-router-dom";
import { get } from "lodash";

import { URLS } from "../../utils";

import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Media, PricePlanTier } from "../../interfaces";
import { AppContext } from "../../providers";
import { DestinationChoicesModal } from "./components/DestinationChoicesModal";
import { VideoPageModal } from "../VideoPages";
import { RecordVideo } from ".";
import { fromMedia, PlayerPostDialog } from "@/components";

type Props = RouteComponentProps;

const RecordVideoFC: React.FC<Props> = ({ history, location }) => {
  const { userContext } = useContext(AppContext);

  const [showPostModal, setShowPostModal] = useState(false);
  const [showVideoPageModal, setShowVideoPageModal] = useState(false);
  const [showChoicesModal, setShowChoicesModal] = useState(false);
  const [selectedDestination, setSelectedDestination] = useState<"videoProject" | "post" | "videoPage">();
  const [recordedMedia, setRecordedMedia] = useState<Media>();

  const subscriptionType: string = get(userContext, "subscriptions[0].pricePlan.tier", "");
  const isSocialCoachPlus = subscriptionType === PricePlanTier.PLAYER_PLUS;
  const [secondsRecorded, setSecondsRecorded] = useState(0);

  const purpose: string = get(location, "state.purpose", "");
  const scriptId = Number(get(location, "state.id", undefined)) || undefined;

  useEffect(() => {
    switch (selectedDestination) {
      case "videoProject":
        history.push(URLS.player.newVideoProject, { preloadMedia: recordedMedia, scriptId });
        break;
      case "post":
        setShowPostModal(true);
        break;
      case "videoPage":
        setShowVideoPageModal(true);
        break;
    }
  }, [selectedDestination]);

  const handleDone = useCallback(
    (media: Media, secondsRecorded: number) => {
      setRecordedMedia(media);
      setSecondsRecorded(secondsRecorded);
      if (purpose == "post" || purpose == "videoProject" || purpose == "videoPage") {
        setSelectedDestination(purpose);
      } else {
        setShowChoicesModal(true);
      }
    },
    [purpose]
  );

  const goBack = () => {
    history.goBack();
  };
  const initialScript: string = get(location, "state.script", "");

  const videoPageModalInitialObject = useMemo(() => {
    if (recordedMedia) return { media: recordedMedia };
    return undefined;
  }, [recordedMedia]);

  return (
    <div className="block min-h-screen bg-white p-5">
      <RecordVideo initialScript={initialScript} onCancel={goBack} onDone={handleDone} />
      {showPostModal && (
        <PlayerPostDialog
          open={showPostModal}
          handleClose={() => setShowPostModal(false)}
          defaults={fromMedia(recordedMedia, secondsRecorded, initialScript)}
        />
      )}
      <VideoPageModal
        open={showVideoPageModal}
        initialObject={videoPageModalInitialObject}
        onClose={() => setShowVideoPageModal(false)}
      />
      <DestinationChoicesModal
        open={showChoicesModal}
        hasSCPlus={isSocialCoachPlus}
        okHandler={choice => {
          setShowChoicesModal(false);
          setSelectedDestination(choice);
        }}
        onClose={() => setShowChoicesModal(false)}
      />
    </div>
  );
};

export const RecordVideoPage = withRouter(RecordVideoFC);
